import { useQueryParam } from 'labguard-cdk'

/**
 * Provide a calendar display mode state and updater
 * Currently stored in query params
 */
export default function useSelectedCalendarMode() {
  const [value = 'month', onChange] = useQueryParam('mode')
  return [value, onChange]
}
